import { HttpMethod } from "./backend.constants";
import { HspBackendCall } from "./wee-backend.call";

export class CheckRightsCall
    extends HspBackendCall<void, boolean> {
    method = HttpMethod.GET;
    endpoint = 'api/user/check';
}